const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

const formatNumCoin = require('../../../../../../../../utils/formatNumCoin');
const formatNumFiat = require('../../../../../../../../utils/formatNumFiat');

const Tooltip = require('../../../../../../../dumb/Tooltip/B');
const RefTableRow = require('../../../../../../../dumb/TableRow/RefTableRow');
const {AdminTimeCell} = require('../../../../../../../dumb/TableTimeCell');

module.exports = ({data, index}) => {
  return (
    <RefTableRow
      className="(wmin130|w1/5)>1"
      index={index}
    >
      <div>
        {data.retailer_name}
      </div>
      <div>
        <Tooltip className="fhaS">
          {data.payment_id}
        </Tooltip>
      </div>
      <div>
        <AdminTimeCell date={data.date} />
      </div>
      <div>
        <Tooltip title={data.fiat_amount} className="fhaS">
          {formatNumFiat(data.fiat_amount)} {data.fiat_code}
        </Tooltip>
        <Tooltip title={data.referral_fiat_amount} className="fhaS fw4 lh14 c717275">
          {formatNumCoin(data.referral_fiat_amount)} {data.referral_fiat_code}
        </Tooltip>
      </div>
      <div>
        <Tooltip title={data.referral_fee} className="fhaS">
          {formatNumFiat(data.referral_fee)} {data.referral_fiat_code}
        </Tooltip>
      </div>
    </RefTableRow>
  )
}
